import React, {useMemo} from "react";
import {IntlProvider} from "react-intl";
import deMessages from '../locales/de.json';
import enMessages from '../locales/en.json';

function flattenObject(obj, parentKey = '', result = {}) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        flattenObject(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
}

const formats = {
  date: {
    short: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
  },
};

const I18nProvider = ({ children, locale }) => {
  const messages = useMemo(() => {
    const rawMessages = locale === 'en' ? enMessages : deMessages;
    return flattenObject(rawMessages);
  }, [locale]);

  return (
    <IntlProvider messages={messages} locale={locale || "de"} defaultLocale={locale || "de"} formats={formats}>
      {children}
    </IntlProvider>
  );
};

export default I18nProvider;
